const labelFromValue = (value) => String(value ?? '');

const ConfigEditor = ({ editor, config, onChangeContent }) => {
  if (!editor || !config) return null;
  const parsed = config.parse(editor.content || '');
  const { values, extraKeys } = parsed;

  const updateValue = (key, nextValue) => {
    const nextValues = { ...values, [key]: nextValue };
    const nextContent = config.serialize({ ...parsed, values: nextValues });
    onChangeContent(nextContent);
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="text-xs font-semibold text-textMuted">Config view</div>
      <div className="text-sm text-textPrimary/80">{config.title}</div>
      <div className="mt-3 flex-1 min-h-0 overflow-y-auto space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          {config.schema.map((field) => {
            const rawValue = Object.prototype.hasOwnProperty.call(values, field.key) ?
            values[field.key] :
            '';
            const isBoolean = field.type === 'boolean';
            const isSelect = field.type === 'select';
            const isNumber = field.type === 'number';
            const displayValue = labelFromValue(rawValue);
            const checked = String(displayValue).toLowerCase() === 'true';

            return (
              <div key={field.key} className="rounded-xl border border-border bg-inset/60 p-3">
                <div className="flex items-start justify-between gap-3">
                  <div className="space-y-1">
                    <label className="text-sm font-semibold text-white">{field.label}</label>
                    <p className="text-xs text-textMuted">{field.description}</p>
                  </div>
                  {isBoolean ?
                  <label className="flex items-center gap-2 text-xs text-textMuted">
                      <input
                      type="checkbox"
                      className="accent-accent"
                      checked={checked}
                      onChange={(e) => updateValue(field.key, e.target.checked ? 'true' : 'false')} />
                    
                      {checked ? 'Enabled' : 'Disabled'}
                    </label> :
                  null}
                </div>
                {!isBoolean ?
                <div className="mt-3">
                    {isSelect ?
                  <select
                    className="w-full rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white focus:border-accent focus:outline-none"
                    value={displayValue}
                    onChange={(e) => updateValue(field.key, e.target.value)}>
                    
                        <option value="">(blank)</option>
                        {(field.options || []).map((opt) =>
                    <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                    )}
                      </select> :

                  <input
                    className="w-full rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
                    type={isNumber ? 'number' : 'text'}
                    value={displayValue}
                    onChange={(e) => updateValue(field.key, e.target.value)} />

                  }
                  </div> :
                null}
              </div>);

          })}
        </div>

        {extraKeys.length > 0 ?
        <div className="rounded-xl border border-border bg-inset/60 p-3">
            <div className="text-xs font-semibold text-textMuted">
              Other settings
            </div>
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
              {extraKeys.map((key) =>
            <div key={key} className="space-y-2">
                  <label className="text-sm font-semibold text-white">{key}</label>
                  <input
                className="w-full rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
                value={labelFromValue(values[key])}
                onChange={(e) => updateValue(key, e.target.value)} />
              
                </div>
            )}
            </div>
          </div> :
        null}
      </div>
    </div>);

};

export default ConfigEditor;